import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function truncateFileName(fileName: string, maxLength: number = 30): string {
    if (fileName.length <= maxLength) return fileName;
    const extension = fileName.slice(fileName.lastIndexOf('.'));
    const truncatedName = fileName.slice(0, maxLength - extension.length - 3);
    return `${truncatedName}...${extension}`;
}

export function kebabToCamelCase(str: string): string {
    return str
        .toLowerCase()
        .split('-')
        .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
        .join('');
}

export function isVideo(src: string) {
  const videoExtensions = ['mp4', 'webm', 'ogg'];
  const ext = src.split('.').pop()?.toLowerCase();
  return videoExtensions.includes(ext ?? '');
};

export const formatNumber = (num: number) => {
    if (num >= 1_000) {
        return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    if (num >= 1_000_000) {
        return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    return num.toLocaleString();
};
